import { type ReactNode } from 'react'

import { cn } from '@/utils/commonUtil'

import styles from './InputWithLabel.module.scss'

type Props = {
  children: ReactNode
  label: string
  variant?: 'horizontal'
}

export const InputWithLabel = ({ children, label, variant }: Props) => (
  <span className={cn(styles.container, { styles, variant })}>
    <span className={styles.label}>
      <span>{label}</span>
    </span>
    <span className={styles.field}>{children}</span>
  </span>
)
